import type {TitleProps} from '@Panels/cancel-subscription-panel/cancel-subscription-panel.types';
import {updateStep} from '@Panels/cancel-subscription-panel/cancel-subscription-reducer';
import {closeModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {TransitionDirection} from '@Panels/transitionable-panel-v2/transitionable-panel-v2.types';

export enum CancelSubscriptionPanelStep {
  FEATURE_USAGE = 'feature-usage',
  SURVEY = 'survey',
  PAUSE = 'pause',
}

export enum CancelSurveyReasonIDs {
  WILL_SUBSCRIBE_AGAIN = 'will-subscribe-again',
  PRICE_TOO_HIGH = 'price-too-high',
  NOT_USING_ENOUGH = 'not-using-enough',
  TROUBLE_WITH_PMW_AI = 'trouble-with-pmw-ai',
  NOT_ENOUGH_DESIGN_FEATURES = 'not-enough-design-features',
  NOT_ENOUGH_TEMPLATE_VARIETY = 'not-enough-template-variety',
  DONT_UNDERSTAND_HOW_TO_USE = 'dont-understand-how-to-use',
  OTHER = 'other',
  NONE = 'none',
}

export enum PauseIntervals {
  ONE_MONTH = 1,
  TWO_MONTHS = 2,
  THREE_MONTHS = 3,
}

export function getFormattedDateForPauseInterval(interval: PauseIntervals, subscriptionExpiresOnTimestamp: number | null): string {
  const date = subscriptionExpiresOnTimestamp === null ? new Date() : new Date(subscriptionExpiresOnTimestamp * 1000);
  date.setMonth(date.getMonth() + interval.valueOf());
  return formatDate(date);
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString('en-us', {month: 'long', day: 'numeric', year: 'numeric'});
}

export function getTitleForStep(step: CancelSubscriptionPanelStep, showPauseOnly: boolean, showDefaultFeatureUsages: boolean): TitleProps {
  let title = '',
    showBackButton = false;
  if (showPauseOnly || step === CancelSubscriptionPanelStep.PAUSE) {
    title = window.i18next.t('pmwjs_pause_your_subscription');
    showBackButton = showPauseOnly !== undefined && !showPauseOnly;
  }

  if (step === CancelSubscriptionPanelStep.FEATURE_USAGE) {
    title = window.i18next.t(showDefaultFeatureUsages === null ? 'pmwjs_are_you_sure_you_want_to_cancel' : 'pmwjs_wait_dont_let_your_creativity_go_to_waste');
  }

  if (step === CancelSubscriptionPanelStep.SURVEY) {
    title = window.i18next.t('pmwjs_why_do_you_want_to_cancel');
    showBackButton = true;
  }

  return {
    text: title,
    showBackButton: showBackButton,
  };
}

export function goBackToPreviousStep(): void {
  const step = window.PMW.redux.store.getState().cancelSubscriptionPanel.currentStep;

  let previousStep = null;
  if (step === CancelSubscriptionPanelStep.SURVEY) {
    previousStep = CancelSubscriptionPanelStep.FEATURE_USAGE;
  } else if (step === CancelSubscriptionPanelStep.PAUSE) {
    previousStep = CancelSubscriptionPanelStep.SURVEY;
  }

  if (previousStep !== null) {
    window.PMW.redux.store.dispatch(
      updateStep({
        step: previousStep,
        direction: TransitionDirection.BACKWARD,
      })
    );
  }
}

export function closeCancelSubscriptionModal(): void {
  window.PMW.redux.store.dispatch(closeModal(MODALS_IDS.CANCEL_SUBCSRIPTION_MODAL));
}

export function onThunkError(): void {
  alert(window.i18next.t('pmwjs_error_message'));
}
